<template>
  <div id="cartDesktop">
    <div  v-if="!getMobile" id="navigation">
      <div style="position: relative;">
        <Navigation />
      </div>
    </div>
    <div v-if="getMobile">
      <NavigationMobile />
    </div>

    <div v-if="getOrder.totalPrice>0 && !completed" :class="{leftRightElement : !getMobile, mobile : getMobile}" id="cartMain">
      <div>
        <CartProductList  :position="'cart'"/>
        <v-card class="mx-auto cardWrapper" width="350px" color="var(--accentColorShaded)" >
          <div class="card">
            <!-- <v-icon large style="color:var(--mainColor);">mdi-percent-outline</v-icon> -->
            <img src="./../../public/icons/discount.svg" height="60px"/>
            <h3 style="color: var(--mainColor); text-align: left;">{{getText.tableConfigurator.bulletpoints[3]}}</h3>
          </div>
        </v-card>
        <router-link to="/configuratorDesktop">
          <v-btn @click="configButton" class="ma-2" color="var(--accentColor)">
            <span style="color:var(--mainColor);">{{getText.cart.productLink}}</span>
          </v-btn>
        </router-link>
      </div>
      <div>
        <div v-if="cancelled" id="cancelled">
          <h3>
          {{getText.cart.orderFailure}}
          </h3>
        </div>
        <ContactForm />
        <div v-if="!getOutsideGermany" :class="{checkoutDesktop : !getMobile}">
          <!-- <h2>
            {{getText.cart.checkoutNow1}}<span id="priceCart">{{getOrder.totalPrice}}</span>{{getText.cart.checkoutNow2}}
          </h2>
          <p v-if="getOrder.customer.shipping">
            {{getText.cart.checkoutWidthShipping}}
          </p>
          <p v-else>
            {{getText.cart.checkoutWidthoutShipping}}
          </p>
          <PayPal
            v-if="!getOutsideGermany"
            :amount=getOrder.paypalPriceString
            currency="EUR"
            :client="paypal"
            v-on:payment-authorized="paymentAuthorized($event)"
            v-on:payment-completed="paymentCompleted($event)"
            v-on:payment-cancelled="paymentCancelled($event)"
            >
          </PayPal>
          <div
              data-pp-message
              data-pp-style-layout="text"
              data-pp-style-logo-type="inline"
              data-pp-style-text-color="black"
              :data-pp-amount="getOrder.totalPrice"
              style="max-width: 200px; margin: auto; padding-top: 15px;">
          </div> -->


          <v-btn @click="paymentCompleted()" class="ma-2" color="var(--accentColor)" height="150px">
            <!-- <span style="color:var(--mainColor);">{{getText.cart.buyViaTransfer}}</span> -->
            <span style="color:var(--mainColor);">Wir arbeiten an dem Bezahlprozess. <br>Bitte schreibe eine email an <br>julian@rho-17.de<br>wenn du deine Bestellung<br>abschließen möchtest.</span>
          </v-btn>
        </div>
        <div v-if="getOutsideGermany" :class="{checkoutDesktop : !getMobile}">
          <v-btn @click="reserve()" class="ma-2" color="var(--accentColor)">
            <span style="color:var(--mainColor);">{{getText.cart.reserve}}</span>
          </v-btn>
        </div>
      </div>
    </div>
    <div v-if="getOrder.totalPrice == 0 && !completed">
      <h1 style="margin: 30px 0;">{{getText.cart.noProductsInCart}}</h1>
      <router-link to="/configuratorDesktop">
        <v-btn @click="configButtonEmpty" class="ma-2" color="var(--accentColor)">
          <span style="color:var(--mainColor);">{{getText.cart.productLink}}</span>
        </v-btn>
      </router-link>
    </div>

  </div>
</template>

<script>
  import CartProductList from '@/components/CartProductList.vue'
  import ContactForm from '@/components/ContactForm.vue'
  //import PayPal from 'vue-paypal-checkout'
  import Navigation from '@/components/Navigation.vue'
  import NavigationMobile from '@/components/NavigationMobile.vue'
  import router from '@/router/index.js'
  import axios from 'axios'

export default {
  name: 'CartDesktop',
  components: {
    CartProductList,
    // StripeCheckout,
    ContactForm,
    Navigation,
    NavigationMobile,
    //PayPal
  },
  data() {
    return{
      // paypal: {
      //   // sandbox: 'AYLG5XHeNAqKAMy-h3LvhRir6w1DRp1NxS863ZqtmqPNQE8iB4OPXl_QVbYZ4HNtPuGA37AhDVUF-JKq',
      //   production: 'AZ1wDZl04YV-vsPaMEp31bRZjJofYtUxBIhgS_RXmNmO2mMyn8la67co1arXhC3mLc8MHCwTFHWr3Ri3'
      // },
      cancelled: false,
      completed: false,
      reserved: false,

      customerOrigin: {normalOrigin: "", otherOrigin:""},

      loaded: false,
      paidFor: false,

      sessionID: '',
      // stripePublicKey:'pk_test_51I5cfIBOYIlmmYJBXu5x9luLtU5R0AOZqHQ4CXecGfhTy70dSdCPWru7g9gPkyzniRQPV605AGANgkmFE1izSX1f00CWngOzpH',
      stripePublicKey:'pk_live_51I5cfIBOYIlmmYJBzlUUyjgDBBxACGU4sd8YNf8u6K79BlB7Q6WjwMoAnypQj1GqY7ciOw9VSmCXIbkzbrihUMIu00XGKm5Mp8',
    }
   },
   computed: {
     getCheckoutEnabler(){return this.$store.state.voucher.vouchers[0].used},
     getOutsideGermany(){return this.$store.getters.getCustomerInformation.outsideGermany},
     getText(){return this.$store.getters.getText},
     getMobile(){return this.$store.getters.getAnimationProperties.mobile;},
     getOrder(){ return this.$store.getters.getOrder; }
   },
   methods: {
     stripeCheckout(){
       var data = [
       //   {
       //   firstname: this.getOrder.customer.firstname,
       //   lastname: this.getOrder.customer.lastname,
       //   email: this.getOrder.customer.email,
       //   street: this.getOrder.customer.street,
       //   zip: this.getOrder.customer.zip,
       //   city: this.getOrder.customer.city,
       //   totalPrice: Math.floor( this.getOrder.totalPrice )*100,
       //   id: this.getOrder.orderID
       // }
       ]

      //  this.getOrder.products.forEach(function(item){
      //    var price = 0
      //    if(item.discount){
      //      price = item.discountPrice * 100
      //    } else {
      //      price = item.price * 100
      //    }
      //    var product = {
      //      name: item.name,
      //      amount: price,
      //      currency: 'eur',
      //      quantity: 1,
      //    }
      //    data.push(product);
      // });
      data.push(this.getOrder)

      axios.get('https://us-central1-furnitures-7a3b4.cloudfunctions.net/checkoutSession', {
      // axios.get('http://localhost:5000/furnitures-7a3b4/us-central1/checkoutSession', {
         params: {
           data
         }
       })
       .then(response => {
         this.sessionID = response.data.id
         this.$refs.checkoutRef.redirectToCheckout();
       })
       .catch(error => {
         console.log(error)
       });
     },
     sendCustomerOrigin(){
       this.$store.dispatch("sendMessage", this.customerOrigin);
       router.push('/')
     },
     configButton(){
     },
     configButtonEmpty(){
     },
     removeProduct(index){
       this.$store.dispatch("deleteFromCart", index)
       // this.stripeGetID()

     },
     paymentAuthorized(){
       this.cancelled = false
     },
     paymentCompleted(){
       this.cancelled = false
       this.$store.dispatch("buyingApproved");
       if (this.getOrder.totalPrice > 20){
         window.fbq('track', 'Purchase', {currency: "EUR", value: this.getOrder.totalPrice});
       } else {
         window.fbq('track', 'StartTrial');
       }
       this.completed = true
       var path = '/orderCompleted?orderID=' + this.getOrder.orderID + '&orderValue=' + this.getOrder.totalPrice
       router.push(path)
     },
     reserve(){
       router.push('/orderReserved')
       this.$store.dispatch("orderReserved");
     },
     paymentCancelled(){
       this.cancelled = true
     },


   },
   mounted (){
     this.$store.dispatch("setNavbarActive", 6);
     // this.stripeGetID()
     window.scrollTo(0, 0)




      // PAYPAL plus
    // const script = document.createElement("script");
    // script.src =
    //     "https://www.paypal.com/sdk/js?client-id=AYLG5XHeNAqKAMy-h3LvhRir6w1DRp1NxS863ZqtmqPNQE8iB4OPXl_QVbYZ4HNtPuGA37AhDVUF-JKq";
    // script.addEventListener("load", this.setLoaded);
    // document.body.appendChild(script);

   },
}
</script>

<style scoped>
.checkoutDesktop{
  max-width: 350px;
  box-sizing: content-box;
  padding: 0 100px;
}
.cardWrapper{
  margin: 15px 0;
}
.card{
  position: relative;
  display: grid;
  grid-template-columns: 80px 1fr;
  padding: 15px 10px 15px 0;
}
  .mobile{
    margin: 0 10px;
  }
  #cartDesktop {
    position: relative;
    top: var(--desktopNavigationHeight);
    padding-bottom: 60px;
  }
  #cartMain {
    min-height: calc(90vh - var(--desktopNavigationHeight));
  }
  #cancelled{
    width: 285px;
    background-color: #F99;
    margin: auto;
    padding: 20px 0;
  }

</style>
